import { Grid, Switch } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { IContactGroup } from 'contacts/types';
import { InfoCard, SlidingPanelContent } from 'core/components';
import { Variant } from 'theme/enums';

import { UpdateContactGroupButton } from './UpdateContactGroupButton';

interface IProps {
  contactGroup: IContactGroup;
  onSubmitSuccess?: (contactGroup: IContactGroup) => void;
}

export const ContactGroupSettings = ({ contactGroup, onSubmitSuccess }: IProps) => {
  const { t } = useTranslation();

  const slidingPanelExtra = (
    <UpdateContactGroupButton contactGroup={contactGroup} onSubmitSuccess={onSubmitSuccess} />
  );

  const leftSideItems = [
    { label: t('labelContactGrouping'), value: contactGroup.contactGroupingName },
    { label: t('labelCustomerNumber'), value: contactGroup.externalCustomerNumber },
    { label: t('labelAcctsReceivableId'), value: contactGroup.accountsReceivableId },
    {
      label: t('labelContactGroupIsCustomer'),
      value: (
        <Switch checked={Boolean(contactGroup.isCustomer)} disabled variant={Variant.OUTLINED} />
      ),
    },
    {
      label: t('labelContactGroupIsVendor'),
      value: (
        <Switch checked={Boolean(contactGroup.isVendor)} disabled variant={Variant.OUTLINED} />
      ),
    },
    {
      label: t('labelContactGroupAutomatedPricing'),
      value: (
        <Switch
          checked={Boolean(contactGroup.automatedPricing)}
          disabled
          variant={Variant.OUTLINED}
        />
      ),
    },
    {
      label: t('labelContactGroupAutoLeadTimeEnabled'),
      value: (
        <Switch
          checked={Boolean(contactGroup.autoLeadTimeEnabled)}
          disabled
          variant={Variant.OUTLINED}
        />
      ),
    },
    {
      label: t('labelContactGroupShowInventory'),
      value: (
        <Switch checked={Boolean(contactGroup.showInventory)} disabled variant={Variant.OUTLINED} />
      ),
    },
    {
      label: t('labelContactGroupFreightEnabled'),
      value: (
        <Switch
          checked={Boolean(contactGroup.freightEnabled)}
          disabled
          variant={Variant.OUTLINED}
        />
      ),
    },
  ];
  const rightSideItems = [
    {
      label: t('labelDomains'),
      value: contactGroup.domains,
    },
    {
      label: t('labelVendorId'),
      value: contactGroup.legacyVendorNumbers?.[0],
    },
    { label: t('labelVendorName'), value: contactGroup.legacyVendorName },
    {
      label: t('labelAlternateVendorId'),
      value: contactGroup.alternateVendorId,
    },
    {
      label: t('labelAlternateVendorName'),
      value: contactGroup.alternateVendorName,
    },
  ];

  return (
    <SlidingPanelContent title={t('labelSettings')} extra={slidingPanelExtra}>
      <Grid container spacing={3}>
        <Grid xs={12} md={6} lg={6}>
          <InfoCard items={leftSideItems} />
        </Grid>

        <Grid xs={12} md={6} lg={6}>
          <InfoCard items={rightSideItems} />
        </Grid>
      </Grid>
    </SlidingPanelContent>
  );
};
